// extracted by mini-css-extract-plugin
export default {"section-container":"TmRpjA","title":"mDofOp","readonly-container":"yP9B0W","readonly-wrapper":"IbyGzD","banner-container":"F0uwe6","icon":"ogfxRt","description":"V1QmEt"};